export function Footer() {
  // Handle client-side navigation
  const handleNavigation = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault()
    window.history.pushState({}, '', href)
    window.dispatchEvent(new Event('popstate'))
  }

  return (
    <footer className="bg-dark-section text-white pt-10 md:pt-20">
      <div className="text-center py-8 border-t border-gray-800">
        <h2 className="text-5xl text-white font-bold mb-8 md:mb-16  uppercase tracking-wide">WE DO <span className="underline text-beaver-red">DAM</span> GOOD WORK</h2>
        <div className="flex flex-wrap justify-center gap-4 md:gap-0 md:space-x-16 mb-6">
          {/* Social Media Icons */}
          <a 
            href="https://www.facebook.com/BusyBeaverConstruction/" 
            className="text-white hover:text-beaver-green"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/images/2020/03/facebook.png" alt="Facebook" className="w-16 h-16 md:w-32 md:h-32" />
          </a>
          <a 
            href="https://x.com/busybeaverconst" 
            className="text-white hover:text-beaver-green"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/images/2020/03/twitter.png" alt="Twitter" className="w-16 h-16 md:w-32 md:h-32" />
          </a>
          <a 
            href="https://www.instagram.com/busybeaverconstruction/" 
            className="text-white hover:text-beaver-green"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/images/2020/03/instagram.png" alt="Instagram" className="w-16 h-16 md:w-32 md:h-32" />
          </a>
          <a 
            href="https://cl.pinterest.com/busybeaverconstruction/_created/" 
            className="text-white hover:text-beaver-green"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/images/2020/03/pinterest.png" alt="Pinterest" className="w-16 h-16 md:w-32 md:h-32" />
          </a>
          <a 
            href="https://www.google.ca/search?_ga=2.188504621.489512805.1616399652-719827988.1614379745&q=Busy+Beaver+Construction+Ltd.&ludocid=7900159961610779435&lsig=AB86z5WidZ9NxwBjYsRX-1I2Vnte" 
            className="text-white hover:text-beaver-green"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/images/2020/03/google.png" alt="Google" className="w-16 h-16 md:w-32 md:h-32" />
          </a>
          <a 
            href="https://www.bbb.org/ca/ab/calgary/profile/deck-builder/busy-beaver-construction-ltd-0017-38381" 
            className="text-white hover:text-beaver-green pt-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/images/2020/03/bbb.png" alt="BBB" className="w-28 h-16 md:w-44 md:h-28" />
          </a>
        </div>
      </div>
      
      {/* Full-width black background section */}
      <div className="w-full bg-black">
        <div className="container py-10 md:py-20 border-t border-gray-800">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl md:text-2xl text-white font-bold mb-3">Contact</h3>
              <address className="not-italic mb-4 text-sm lg:text-lg">
                86 West Point Mews SW,<br />
                Calgary, AB T3H 0X5
              </address>
              <p className="text-sm lg:text-lg">
                <a href="tel:4032865400" className="text-beaver-red hover:text-white">
                  403-286-5400
                </a>
              </p>
              <p className="text-sm lg:text-lg">
                <a href="mailto:sales@busybeaverconstruction.com" className="text-beaver-red hover:text-white">
                  sales@busybeaverconstruction.com
                </a>
              </p>
              <p className="text-sm lg:text-lg">
                <a href="https://busybeaverconstruction.com" className="text-beaver-red hover:text-white" target="_blank" rel="noopener noreferrer">
                  www.busybeaverconstruction.com
                </a>
              </p>
            </div>
            
            <div className="flex flex-col items-center md:items-end mt-8 md:mt-[-120px] justify-center">
              <h3 className="text-lg italic font-bold mb-4 text-white text-center md:text-right md:whitespace-nowrap">Contact Calgary's leading custom deck and fence contractor</h3>
              <a 
                href="/appointment" 
                className="bg-beaver-green text-black px-6 py-3 font-bold uppercase text-sm rounded hover:brightness-110 transition-all duration-300 inline-block"
                onClick={(e) => handleNavigation(e, '/appointment')}
              >
                BOOK FREE ESTIMATE
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
} 